// eslint-disable-next-line no-unused-vars
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { bool } from 'prop-types';

import useCart from 'Hooks/useCart';
import useRouter from 'Hooks/useRouter';
import useScreen from 'Hooks/useScreen';
import useScrollLock from 'Hooks/useScrollLock';
import CartAndWishlistsComponent from 'Components/CartAndWishlists/CartAndWishlists';
import useOutsideClick from 'Hooks/useOutsideClick';

const CartAndWishlists = ({ canFloat }) => {
  // eslint-disable-next-line no-unused-vars
  const { location, push } = useRouter();
  const { data: cart } = useCart();
  const { width: screenWidth } = useScreen();
  const [active, setActive] = useState(null);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const isVisible = useOutsideClick(ref);
  const isDesktop = screenWidth > 767;

  useEffect(() => {
    if (isDesktop) {
      setOpen(isVisible);
    }
  }, [isVisible]);

  useEffect(() => {
    if (open) {
      setOpen(false);
    }
  }, [location.pathname]);

  const handleOnToggle = idx => e => {
    if (
      idx === false
      && e?.keyCode !== 27
    ) return;

    if (e?.keyCode === 27) {
      setOpen(false);
      return;
    }

    if (idx === active) {
      setOpen(!open);
    } else {
      setOpen(true);
    }

    setActive(idx);
  };

  const handleOnToggleMobile = idx => e => {
    if (
      idx === false
      && e?.keyCode !== 27
    ) return;

    let path;

    if (idx === 0) {
      path = '/offers';
    }

    if (idx === 1) {
      path = '/lists';
    }

    if (idx === 2) {
      path = '/checkout';
    }

    if (path) {
      push(path);
    }
  };

  const handleOnClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleOnEscape = useCallback(
    e => {
      if (e.keyCode === 27) {
        setOpen(false);
      }
    },
    []
  );

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('keydown', handleOnEscape);
    }

    return () => {
      if (typeof document !== 'undefined') {
        document.removeEventListener('keydown', handleOnEscape);
      }
    };
  }, [ref]);

  useScrollLock(open);

  return (
    <CartAndWishlistsComponent
      ref={ ref }
      onToggle={ isDesktop ? handleOnToggle : handleOnToggleMobile }
      onClose={ handleOnClose }
      open={ open }
      cart={ cart }
      activeTab={ active }
      onSetActive={ setActive }
      canFloat={ canFloat }
    />
  );
};

CartAndWishlists.propTypes = {
  canFloat: bool
};

export default CartAndWishlists;
